var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2911_997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 9.43896V18.3533",
    stroke: "#5C5C5C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4262 15.6088C28.3685 15.0638 29.1129 14.2015 29.5419 13.1578C29.9709 12.1141 30.0601 10.9486 29.7954 9.84523C29.5306 8.74183 28.9271 7.76338 28.08 7.0643C27.2328 6.36522 26.1904 5.98532 25.1171 5.98457H23.8998C23.6073 4.7846 23.0623 3.67058 22.3056 2.72625C21.5489 1.78193 20.6002 1.03187 19.531 0.532471C18.4617 0.0330721 17.2996 -0.202672 16.1321 -0.157037C14.9646 -0.111403 13.822 0.214422 12.7902 0.795942C11.7585 1.37746 10.8645 2.19954 10.1753 3.20038C9.48618 4.20122 9.01987 5.35478 8.81147 6.57432C8.60306 7.79386 8.65797 9.04766 8.97207 10.2414C9.28617 11.4352 9.85129 12.5379 10.6249 13.4667",
    stroke: "#5C5C5C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0858 13.5533L19.3144 9.43896L15.543 13.5533",
    stroke: "#5C5C5C",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2911_997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3143,
    height: 24,
    fill: "white",
    transform: "translate(0.599747)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.065ba9e8e4357c4becd124fc00447525.svg";
export { ForwardRef as ReactComponent };